import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ComplianceOverview } from './complianceTypes'

export interface ComplianceState {
  overview: ComplianceOverview | null
  overviewLoading: boolean
  overviewError: boolean
}

const initialState: ComplianceState = {
  overview: null,
  overviewLoading: false,
  overviewError: false,
}

const complianceSlice = createSlice({
  name: 'compliance',
  initialState,
  reducers: {
    setOverviewLoading(state) {
      state.overviewLoading = true
      state.overviewError = false
    },
    getComplianceOverviewSuccess(
      state,
      action: PayloadAction<ComplianceOverview>
    ) {
      state.overview = action.payload
      state.overviewLoading = false
      state.overviewError = false
    },
    getComplianceOverviewFailed(state) {
      state.overviewLoading = false
      state.overviewError = true
    },
  },
})

export const complianceReducers = complianceSlice.actions
export const complianceReducer = complianceSlice.reducer
